import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import { services, whyChooseUs } from "@/mock";

const HomePage = ({ onBookNow }) => {
  return (
    <>
      <Header onBookNow={onBookNow} />
      <Hero onBookNow={onBookNow} />
      <Services services={services} />
      <WhyChooseUs features={whyChooseUs} />
      <ContactSection />
      <Footer />
    </>
  );
};

function App() {
  const clinicsenseBookingUrl = "http://practice-5f8c304b.clinicsense.com/book/";

  const handleBookNow = () => {
    // Redirect to Clinicsense booking page
    window.open(clinicsenseBookingUrl, '_blank');
  };

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage onBookNow={handleBookNow} />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
